import { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { missionDraftForm2ApiMapper } from '../mappers/mission-draft.form2api.mapper';
import type { MissionForm_Mission } from '../fragments/mission.fragment';

export const MissionForm_ActorsStep_CreationAccess_QueryDocument = graphql(`
  query MissionForm_ActorsStep_CreationAccess_Query($mission: MissionInput!) {
    missionCreationAccess(mission: $mission) {
      details {
        fr
      }
    }
  }
`);

// Why the creation of the mission, as the form holds it, will be refused (creating takes the roles
// held through its internal actors); none when it will be allowed, or out of a creation.
export const useMissionCreationRefusal = (
  isCreation: boolean,
): string | null => {
  const { codingStrategiesCodeMap } = useReferencesContext();
  const { values } = useFormikContext<MissionForm_Mission>();

  const mission = useMemo(
    () =>
      missionDraftForm2ApiMapper(
        values,
        codingStrategiesCodeMap.CodingConfigAutomatic._id,
      ),
    [codingStrategiesCodeMap.CodingConfigAutomatic._id, values],
  );

  const { data } = useGraphQLQuery(
    MissionForm_ActorsStep_CreationAccess_QueryDocument,
    { mission },
    { enabled: isCreation },
  );

  const details = data?.missionCreationAccess.details ?? [];

  return details.length ? details.map(({ fr }) => fr).join(' ') : null;
};
